module.exports = __webpack_public_path__ + "img/23.0497c05c.svg";